import { BrowserRouter, Route, Routes } from "react-router-dom";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { App as AntApp } from "antd";

import ForgotPassword from "./pages/forgotPassword/index";
import Login from "./pages/login/index";
import NotFoundPage from "./pages/notFoundPage/notFoundPage";
import Register from "./pages/register/index";
import ResetPassword from "./pages/resetPassword/index";
import VerifyEmail from "./pages/verifyEmail/index";
import { PrivateRoute, PublicRoute } from "./utils/routeHandlers";

const queryClient = new QueryClient();

const App = () => {
  return (
    <AntApp>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter basename="/">
          <Routes>
            <Route element={<PublicRoute />}>
              <Route path="/login" Component={Login} />
              <Route path="/" Component={Login} />
              <Route path="/register" Component={Register} />
              <Route path="/forgot-password" Component={ForgotPassword} />
              <Route path="/reset-password" Component={ResetPassword} />
              <Route path="/verify-email" Component={VerifyEmail} />
            </Route>
            {/* Authenticated area — role-based routing handled inside RouteList */}
            <Route path="/*" element={<PrivateRoute />} />
            <Route path="/404" element={<NotFoundPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </BrowserRouter>
      </QueryClientProvider>
    </AntApp>
  );
};

export default App;
